const handleError = (error) => {
	if (error?.response?.data) {
		throw error.response.data;
	} else if (error?.request) {
		throw error.request;
	}
	throw error;
};

const CaseService = {
	async indexStats(teamId, params) {
		try {
			const response = await axios.get(`/api/cases/${teamId}/stats`, { params });
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async getCases(teamId, params) {
		try {
			const response = await axios.get(`/api/cases/${teamId}`, { params });
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async getCaseDetails(teamId, caseId) {
		try {
			const response = await axios.get(`/api/cases/${teamId}/${caseId}/details`);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async deleteCase(teamId, caseId) {
		try {
			const response = await axios.delete(`/api/cases/${teamId}/${caseId}/delete`);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async updateCase(teamId, caseId, payload) {
		try {
			const response = await axios.post(`/api/cases/${teamId}/${caseId}/update`, payload);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async postComment(teamId, caseId, payload) {
		try {
			const response = await axios.post(`/api/cases/${teamId}/${caseId}/comments`, payload);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async createCase(teamId, payload) {
		try {
			const response = await axios.post(`/api/cases/${teamId}`, payload);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async getSettings(teamId) {
		try {
			const response = await axios.get(`/api/cases/${teamId}/settings`);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async updateDefaults(teamId, payload) {
		try {
			const response = await axios.put(`/api/cases/${teamId}/defaults`, payload);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async createGroup(teamId, data) {
		try {
			const response = await axios.post(`/api/cases/${teamId}/groups`, data);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async updateGroup(teamId, groupId, data) {
		try {
			const response = await axios.put(`/api/cases/${teamId}/groups/${groupId}`, data);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async deleteGroup(teamId, groupId) {
		try {
			const response = await axios.delete(`/api/cases/${teamId}/groups/${groupId}`);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async exportDetailsReport(teamId, payload) {
        try {
            const response = await axios.post(`/api/cases/${teamId}/details-report`, payload);
            return response.data; 
        } catch (error) {
			handleError(error);
        }
    },
	async createDepartment(teamId, data) {
		try {
			const response = await axios.post(`/api/cases/${teamId}/departments`, data);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async updateDepartment(teamId, departmentId, data) {
		try {
			const response = await axios.put(`/api/cases/${teamId}/departments/${departmentId}`, data);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async getDepartments(teamId, params) {
		try {
			const response = await axios.get(`/api/cases/${teamId}/departments`, { params });
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	async saveDepartment(teamId, data, departmentId = null) {
		try {
			if (departmentId) {
				console.log(departmentId);
			}
			const url = departmentId 
			? `/api/cases/${teamId}/departments/${departmentId}` // Update
			: `/api/cases/${teamId}/departments`; // Create
			
			const response = await axios.post(url, data);	
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},
	
	async deleteDepartment(teamId, departmentId) {
		try {
			const response = await axios.delete(`/api/cases/${teamId}/departments/${departmentId}`);
			return response.data;
		} catch (error) {
			handleError(error);
		}
	},

	guest: {
		async indexStats(teamId, params) {
			try {
				const response = await axios.get(`/api/guest/cases/${teamId}/stats`, {
					params,
					headers: { Authorization: `Bearer ${Spark.jwtToken}` },
				});
				return response.data;
			} catch (error) {
				handleError(error);
			}
		},

		async getCases(teamId, params) {
			try {
				const response = await axios.get(`/api/guest/cases/${teamId}`, {
					params,
					headers: { Authorization: `Bearer ${Spark.jwtToken}` },
				});
				return response.data;
			} catch (error) {
				handleError(error);
			}
		},

		async getCaseDetails(teamId, caseId) {
			try {
				const response = await axios.get(`/api/guest/cases/${teamId}/${caseId}`, {
					headers: { Authorization: `Bearer ${Spark.jwtToken}` },
				});
				return response.data;
			} catch (error) {
				handleError(error);
			}
		},

		async postComment(teamId ,caseId, payload) {
			try {
				const response = await axios.post(`/api/guest/cases/${teamId}/${caseId}/comments`, payload, {
					headers: { Authorization: `Bearer ${Spark.jwtToken}` },
				});
				return response.data;
			} catch (error) {
				handleError(error);
			}
		},
	},
};

export default CaseService;
